import { Component, ElementRef, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { Subject } from 'rxjs';
import { EmojiHelperService } from '../_helpers/emojis/emoji-helper.service';
import { ThemeService } from '../_helpers/theming-engine/theme.service';

import * as CryptoJS from 'crypto-js';
import { AuthenticationService, UserService } from '../_services';
import { FeatureHelperService } from '../_helpers/feature-helper/feature-helper.service';
import { ActivatedRoute, Router } from '@angular/router';
import { StudentService } from '../_services/student/student.service';
import { StudentResetPinResponse } from '../_models/student-login/student-reset-pin-response.model';
import { ErrorModalHelperService } from '../_helpers/error-modal-helper/error-modal-helper.service';
import { SuccessModalHelperService } from '../_helpers/success-modal-helper/success-modal-helper.service';

@Component({
    selector: 'app-student-login',
    templateUrl: './student-login.component.html',
    styleUrls: ['./student-login.component.css'],
    standalone: false
})
export class StudentLoginComponent implements OnInit {
  @ViewChild("pin1", { static: false }) pin1: ElementRef;
  @ViewChild("pin2", { static: false }) pin2: ElementRef;
  @ViewChild("pin3", { static: false }) pin3: ElementRef;
  @ViewChild("pin4", { static: false }) pin4: ElementRef;

  private _selectedPinsChanged: Subject<{ method: string, type: string }> = new Subject<{ method: string, type: string }>();
  private unsubscribe: Subject<void> = new Subject<void>();

  public returnUrl: string;

  public showFirstNameRequired: boolean = false;
  public showBirthMonthRequired: boolean = false;
  public showPinRequired: boolean = false;

  public showEmojis: boolean = false;
  public showNumbers: boolean = false;
  public isNumericPin: boolean;
  public isGuidLogin: boolean = false;

  public loginGuid: string = "";

  public firstName: string = "";
  public birthMonth: string = "";
  public selectedPins: Array<string> = new Array<string>();

  public showResetPinPanel: boolean = false;
  public showEmailAddressRequired: boolean = false;
  public emailAddress: string = "";

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public themeService: ThemeService,
    private emojiHelper: EmojiHelperService,
    private viewContainerRef: ViewContainerRef,
    private userService: UserService,
    private successModalHelper: SuccessModalHelperService,
    private authenticationService: AuthenticationService,
    private featureHelperService: FeatureHelperService,
    private studentService: StudentService,
    private errorModalHelper: ErrorModalHelperService
  ) {
    if (this.route.snapshot.queryParamMap.get('guid') != null) {
      this.isGuidLogin = true;
      this.loginGuid = this.route.snapshot.queryParamMap.get('guid');
    }
  }

  ngOnInit() {
    this.themeService.setActiveTheme('LEAP', false);

    this._selectedPinsChanged.subscribe((object: any) => {
      if (object.method == "add") {

        let itemNumber = this.selectedPins.length;

        if (object.type == "pin") {
          this["pin" + itemNumber].nativeElement.innerText = this.selectedPins[itemNumber - 1];
        } else {
          if (!this["pin" + itemNumber].nativeElement.classList.contains(this.selectedPins[itemNumber - 1] + "-emoji")) {
            this["pin" + itemNumber].nativeElement.classList.add(this.selectedPins[itemNumber - 1] + "-emoji");
          }
        }

      } else if (object.method == "remove") {

        let itemNumber = this.selectedPins.length + 1;
        this["pin" + itemNumber].nativeElement.innerText = "";
        let pinList: Array<string> = new Array<string>();
        pinList.push(...this["pin" + itemNumber].nativeElement.classList);
        let pinClassList = pinList.slice(0);
        pinClassList.forEach((className: string) => {
          if (className.indexOf("emoji") != -1) {
            this["pin" + itemNumber].nativeElement.classList.remove(className);
          }
        });

      } else if (object.method == "clear") {

        this.selectedPins = new Array<string>();
        this.pin1.nativeElement.innerText = "";
        let pin1List: Array<string> = new Array<string>();
        pin1List.push(...this.pin1.nativeElement.classList);
        let pin1ClassList = pin1List.slice(0);
        pin1ClassList.forEach((className: string) => {
          if (className.indexOf("emoji") != -1 && className != "pin-box-emoji") {
            this.pin1.nativeElement.classList.remove(className);
          }
        });

        this.pin2.nativeElement.innerText = "";
        let pin2List: Array<string> = new Array<string>();
        pin2List.push(...this.pin2.nativeElement.classList);
        let pin2ClassList = pin2List.slice(0);
        pin2ClassList.forEach((className: string) => {
          if (className.indexOf("emoji") != -1 && className != "pin-box-emoji") {
            this.pin2.nativeElement.classList.remove(className);
          }
        });

        this.pin3.nativeElement.innerText = "";
        let pin3List: Array<string> = new Array<string>();
        pin3List.push(...this.pin3.nativeElement.classList);
        let pin3ClassList = pin3List.slice(0);
        pin3ClassList.forEach((className: string) => {
          if (className.indexOf("emoji") != -1 && className != "pin-box-emoji") {
            this.pin3.nativeElement.classList.remove(className);
          }
        });

        this.pin4.nativeElement.innerText = "";
        let pin4List: Array<string> = new Array<string>();
        pin4List.push(...this.pin4.nativeElement.classList);
        let pin4ClassList = pin4List.slice(0);
        pin4ClassList.forEach((className: string) => {
          if (className.indexOf("emoji") != -1 && className != "pin-box-emoji") {
            this.pin4.nativeElement.classList.remove(className);
          }
        });

      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public login(): void {

    if (this.validateForm()) {


      let messageToHash: string = this.firstName + "" + this.birthMonth;
      let hashSalt: string = this.firstName + "" + this.birthMonth;
      let paddedSalt = hashSalt;//.padEnd(4*((hashSalt.length + 3) / 4), "=");

      if (this.isGuidLogin) {
        messageToHash = messageToHash + "" + this.loginGuid;
      } else {
        this.selectedPins.forEach(pin => {
          if (!this.isNumericPin) {
            messageToHash = messageToHash + "" + this.emojiHelper.getEmojiPin(pin);
          } else {
            messageToHash = messageToHash + "" + pin;
          }
        });
      }

      let base64Hash = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA512(messageToHash.toLowerCase(), paddedSalt.toUpperCase()));

      this.userService.validateStudentAccess(base64Hash).subscribe((response: any) => {
        this.featureHelperService.setUserFeatures(response.userFeatures);
        this.authenticationService.setUser(response);

        this.themeService.setActiveTheme('LEAP');

        setTimeout(() => {
          this.router.navigate(["/"]);
        }, 100);
    
      },
        error => {
          if (error.status === 0) {
            this.errorModalHelper.show("Internal system error, please contact the system administrator", error);
          } else if (error.status === 401) {
            this.errorModalHelper.show("Authentication Failed.", error);
          } else {
            this.errorModalHelper.show(error.message, error);
          }
        });
    }

  }

  private validateForm(): boolean {
    let valid: boolean = true;
    if (this.firstName == "") {
      this.showFirstNameRequired = true;
      valid = false;
    } else {
      this.showFirstNameRequired = false;
    }

    if (this.birthMonth == "") {
      this.showBirthMonthRequired = true;
      valid = false;
    } else {
      this.showBirthMonthRequired = false;
    }

    if (!this.isGuidLogin && this.selectedPins.length < 4) {
      this.showPinRequired = true;
      valid = false;
    } else {
      this.showPinRequired = false;
    }

    return valid;
  }

  public clearPin(): void {
    this.selectedPins = new Array<string>();
    this._selectedPinsChanged.next({ method: "clear", type: "na" });
    this.showPinRequired = false;
  }

  public showEmojiPanel(): void {
    this.selectedPins = new Array<string>();
    this.showNumbers = false;
    this.showEmojis = true;
    this.isNumericPin = false;
    setTimeout(() => {
      this._selectedPinsChanged.next({ method: "clear", type: "na" });
    }, 0);
  }

  public showNumberPanel(): void {
    this.selectedPins = new Array<string>();
    this.showNumbers = true;
    this.showEmojis = false;
    this.isNumericPin = true;
    setTimeout(() => {
      this._selectedPinsChanged.next({ method: "clear", type: "na" });
    }, 0);
  }

  public numberSelected(number: string): void {
    if (this.selectedPins.length < 4) {
      this.selectedPins.push(number);
      this._selectedPinsChanged.next({ method: "add", type: "pin" });
    }
  }

  public numberSelectBackspace(): void {
    if (this.selectedPins.length > 0) {
      this.selectedPins = this.selectedPins.slice(0, -1);
      this._selectedPinsChanged.next({ method: "remove", type: "na" });
    }
  }

  public emojiSelected(emoji: string): void {
    if (this.selectedPins.length < 4) {
      this.selectedPins.push(emoji);
      this._selectedPinsChanged.next({ method: "add", type: "emoji" });
    }
  }

  public submitRestPin(): void {

    if (this.emailAddress != null && this.emailAddress != "") {

      this.studentService.resetPin(this.emailAddress).subscribe((response: StudentResetPinResponse) => {
        if (response.successful) {
          this.successModalHelper.show(response.message);
        } else {
          this.errorModalHelper.show(response.message, {isValidationError: false});
        }
      }, error => {
        this.errorModalHelper.show("Internal system error, please contact the system administrator", error);
      });
    } else {
      this.showEmailAddressRequired = true;
    }
  }
}
